import BizAppDownloadBar from './biz-app-download-bar.vue';

export default BizAppDownloadBar;
